import { Component } from '@angular/core';
import { ReportsService } from './reports.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ProcessingDialogComponent } from '../shared/processing-dialog/processing-dialog.component';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent {

  data: any[] = [];
  uuid: string;

  private processed: boolean;
  private processingDialog: NgbModalRef;
  private timedOut: boolean;

  constructor(
    private report: ReportsService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.report.getAllReports().then(data => {
      if (data) {
        this.data = data;
        if (this.data.length === 1) {
          this.uuid = data[0].report_uuid;
        }
      }

    })
  }

  generateReport() {
    this.processingDialog = this.showProcessingDialog();
    this.startProcessingDialog();

    this.report.getReport(this.uuid).subscribe(blob => {
      const link = document.createElement('a');
      document.body.appendChild(link);
      // make link point to the already downloaded blob object
      link.href = window.URL.createObjectURL(blob);
      // set name of file that user will get
      link.download = 'routeReport' + this.getDateString() + '.xlsx';
      // start "download" by "clicking" link
      link.click();
      // remove link again
      document.body.removeChild(link);

      this.handleProcessingDialog();
    });
  }

  protected showProcessingDialog(): NgbModalRef {
    const modalRef = this.modalService.open(ProcessingDialogComponent, { backdrop: 'static', keyboard: false });
    modalRef.componentInstance.title = 'Henter rapport';
    modalRef.componentInstance.message = 'Dette kan tage lidt tid, afhængigt af rapportens kompleksitet og mængden af data.';
    return modalRef;
  }

  private startProcessingDialog(): void {
    this.timedOut = false;
    this.processed = false;

    setTimeout(() => {
      if (this.processed) {
        this.processingDialog.close();
      } else {
        this.timedOut = true;
      }
    }, 2000);
  }

  private handleProcessingDialog(): void {
    this.processed = true;
    if (this.timedOut) {
      this.processingDialog.close();
    }
  }
  
  private getDateString() {
    const date: Date = new Date();
    const DD = ("0" + date.getDate()).slice(-2);
    const MM = ("0" + (date.getMonth()+1)).slice(-2);
    const YYYY = date.getFullYear();
    return YYYY + MM + DD;
  }

  downloadFile(res: any) {
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(res);
    link.download = 'file';
    link.click();
  }
}

